import { mulV, mulV344 } from "@thi.ng/matrices";
import { copyAttribs } from "./copy-attribs";
export const transformPoints = (pts, mat, op = mulV) => (pts.forEach((p) => op(null, mat, p)), pts);
export const transformedPoints = (pts, mat, op = mulV) => pts.map((p) => op([], mat, p));
export const transformPointsWith = (pts, fn, op = mulV) => (pts.forEach((p) => op(null, fn(p), p)), pts);
export const transformedPointsWith = (pts, fn, op = mulV) => pts.map((p) => op([], fn(p), p));
export const transformedShape = (ctor) => ($, mat) => new ctor(transformedPoints($.points, mat), copyAttribs($));
export const transformedShapePoints = (ctor) => ($, fn) => new ctor(transformedPointsWith($.points, fn), copyAttribs($));
// 3d versions
export const transformPoints3 = (pts, mat) => transformPoints(pts, mat, mulV344);
export const transformedPoints3 = (pts, mat) => transformedPoints(pts, mat, mulV344);
export const transformedPointsWith3 = (pts, fn) => transformedPointsWith(pts, fn, mulV344);
export const transformedShape3 = (ctor) => ($, mat) => new ctor(transformedPoints3($.points, mat), copyAttribs($));
export const transformedShapePoints3 = (ctor) => ($, fn) => new ctor(transformedPointsWith3($.points, fn), copyAttribs($));
